import { render, staticRenderFns } from "./ClientManagement.html?vue&type=template&id=1acb59a6&"
import script from "./ClientManagement.vue?vue&type=script&lang=js&"
export * from "./ClientManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports